module.exports = __webpack_public_path__ + "93105021722b3215f5abf526df3f272c.pdf";